// ファイル名: category-grid.js
// カテゴリーグリッドのインタラクション処理 - ES6準拠

class CategoryGrid {
  constructor(section) {
    this.section = section;
    this.items = section.querySelectorAll('.category-grid-item');
    this.init();
  }

  init() {
    // Intersection Observerでスクロールアニメーション
    this.setupIntersectionObserver();
    
    // キーボードナビゲーション
    this.setupKeyboardNavigation();
    
    // タッチデバイス対応
    this.setupTouchInteractions();
  }

  setupIntersectionObserver() {
    // アニメーション済みかチェック
    if (this.section.dataset.animated) return;

    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.1
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const delay = entry.target.dataset.animationDelay || 0;
          
          setTimeout(() => {
            entry.target.style.animationPlayState = 'running';
          }, delay);
          
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    // 初期状態でアニメーションを一時停止
    this.items.forEach(item => {
      item.style.animationPlayState = 'paused';
      observer.observe(item);
    });

    this.section.dataset.animated = 'true';
  }

  setupKeyboardNavigation() {
    const links = this.section.querySelectorAll('.category-grid-link');
    
    links.forEach((link, index) => {
      link.addEventListener('keydown', (e) => {
        let targetIndex = null;
        
        switch(e.key) {
          case 'ArrowRight':
            targetIndex = index + 1;
            break;
          case 'ArrowLeft':
            targetIndex = index - 1;
            break;
          case 'ArrowDown':
            targetIndex = index + this.getColumnsCount();
            break;
          case 'ArrowUp':
            targetIndex = index - this.getColumnsCount();
            break;
        }
        
        if (targetIndex !== null && links[targetIndex]) {
          e.preventDefault();
          links[targetIndex].focus();
        }
      });
    });
  }

  setupTouchInteractions() {
    if (!('ontouchstart' in window)) return;
    
    this.items.forEach(item => {
      let touchStartY = 0;
      
      item.addEventListener('touchstart', (e) => {
        touchStartY = e.touches[0].clientY;
      }, { passive: true });
      
      item.addEventListener('touchmove', (e) => {
        const touchY = e.touches[0].clientY;
        const deltaY = touchStartY - touchY;
        
        // 垂直スクロールの場合はデフォルト動作を許可
        if (Math.abs(deltaY) > 10) {
          return;
        }
        
        // 水平スワイプの場合はリンクをトリガー
        e.preventDefault();
      }, { passive: false });
    });
  }

  getColumnsCount() {
    const gridComputedStyle = window.getComputedStyle(this.section.querySelector('.category-grid'));
    const columns = gridComputedStyle.getPropertyValue('grid-template-columns').split(' ').length;
    return columns;
  }
}

// DOMContentLoaded時に初期化
document.addEventListener('DOMContentLoaded', () => {
  const categoryGridSections = document.querySelectorAll('.category-grid-section');
  
  categoryGridSections.forEach(section => {
    new CategoryGrid(section);
  });
});

// Shopify Theme Editorでのセクション再読み込み対応
if (Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.category-grid-section');
    if (section) {
      new CategoryGrid(section);
    }
  });
}
